'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function deferred() {
  var def = {};
  def.promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  return def;
}
function arrayOfDeferred(length) {
  var arr = [];

  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }

  return arr;
}

exports.arrayOfDeferred = arrayOfDeferred;
exports.default = deferred;



//////////////////
// WEBPACK FOOTER
// ./~/@redux-saga/deferred/dist/redux-saga-deferred.cjs.js
// module id = 454
// module chunks = 0